import { Injectable } from '@angular/core';
import {
  ApBaseClass,
  ColumnDateDto,
  ColumnFieldType,
  ColumnHyperlinkDto,
  ColumnInfoDto,
  ColumnStringDto,
  ConfigurableTableColumnDto,
  FindControlInitDto,
  IColumnPk,
  ISelected,
} from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class ApConfigurableTableService extends ApBaseClass {

  constructor(
  ) {
    super();
  }

  mapFindConfigToTableConfig(
    configDto: FindControlInitDto,
    clickableMode: boolean,
    onHyperLinkSelect: (dataDto: object) => void
  ): Array<ColumnInfoDto<string>> {
    const tableColumnList: Array<ColumnInfoDto<string>> = configDto.FindControlBehavior.ColumnsConfig.Columns.map((column) => {
      const tableColumnDto = new ColumnInfoDto<string>();
      tableColumnDto.ColumnName = column.ColumnName;
      tableColumnDto.HeaderDisplayName = column.ColumnDisplayName;
      tableColumnDto.Width = column.Width ?? 0;
      tableColumnDto.FieldTypeObject = column.CanSelect && clickableMode ? this.createHyperlinkColumn(
        column,
        (dataDto: IColumnPk & ISelected) => onHyperLinkSelect(dataDto)
      ) : this.createColumn(column);
      tableColumnDto.SortOrder = column.SortOrder;
      tableColumnDto.SortDirection = column.SortDirection;

      if (
        tableColumnDto.FieldTypeObject.FieldType !== ColumnFieldType.Dropdown &&
        tableColumnDto.FieldTypeObject.FieldType !== ColumnFieldType.Html &&
        tableColumnDto.FieldTypeObject.FieldType !== ColumnFieldType.Date
      ) {
        tableColumnDto.Format = { NgStyleProperties: this.italicize };
      }

      return tableColumnDto;
    });

    return tableColumnList;
  }

  mapFilterConfigToTableConfig(
    config: ConfigurableTableColumnDto[], onHyperLinkSelect: (dataDto: object) => void): Array<ColumnInfoDto<string>> {
    const tableColumnList: Array<ColumnInfoDto<string>> = config.map((column) => {
      const tableColumnDto = new ColumnInfoDto<string>();
      tableColumnDto.ColumnName = column.ColumnName;
      tableColumnDto.HeaderDisplayName = column.ColumnDisplayName;
      tableColumnDto.Width = column.Width ?? 0;
      tableColumnDto.FieldTypeObject =
        column.CanSelect ? this.createHyperlinkColumn(column, onHyperLinkSelect) : this.createColumn(column);

      if (
        tableColumnDto.FieldTypeObject.FieldType !== ColumnFieldType.Dropdown &&
        tableColumnDto.FieldTypeObject.FieldType !== ColumnFieldType.Html &&
        tableColumnDto.FieldTypeObject.FieldType !== ColumnFieldType.Date
      ) {
        tableColumnDto.Format = { NgStyleProperties: this.italicize };
      }

      return tableColumnDto;
    });

    return tableColumnList;
  }

  private createHyperlinkColumn(columnDto: ConfigurableTableColumnDto, onHyperLinkSelect: (dataDto: object) => void): ColumnHyperlinkDto {
    const hyperlinkDto: ColumnHyperlinkDto = new ColumnHyperlinkDto({
      HyperlinkCallback: (dataDto: IColumnPk & ISelected) => onHyperLinkSelect(dataDto),
      TextFieldTypeObject: this.createColumn(columnDto),
    });
    return hyperlinkDto;
  }

  private createColumn(columnDto: ConfigurableTableColumnDto): ColumnStringDto | ColumnDateDto {
    if (columnDto.Type) {
      switch (columnDto.Type.toLowerCase()) {
        case ColumnFieldType.String.toLowerCase(): {
          return this.createStringColumn(columnDto);
        }
        case ColumnFieldType.Date.toLowerCase(): {
          return this.createDateColumn(columnDto);
        }
        case ColumnFieldType.DateTime.toLowerCase(): {
          return this.createDateColumn(columnDto, true);
        }
      }
    }
    return this.createStringColumn(columnDto);
  }

  private createStringColumn(columnDto: ConfigurableTableColumnDto): ColumnStringDto {
    const stringDto = new ColumnStringDto({
      FormatCallback: (dataDto: IColumnPk): string => dataDto[columnDto.ColumnName],
    });
    return stringDto;
  }

  private createDateColumn(columnDto: ConfigurableTableColumnDto, isTypeCheck?: boolean): ColumnDateDto {
    const stringDto = new ColumnDateDto({
      FieldType: isTypeCheck ? ColumnFieldType.DateTime : ColumnFieldType.Date,
      DateFormat: isTypeCheck ? 'MM/dd/yyyy h:mm a' : 'M/d/y',
      DateStringCallback: (dataDto: IColumnPk): string => dataDto[columnDto.ColumnName],
    });
    return stringDto;
  }

  private italicize(x: IColumnPk): object {
    return x.Inactive ? { 'font-style': 'italic' } : {};
  }
}
